var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"try-new-banner"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"try-new-link",on:{"click":function($event){return _vm.$emit('switch')}}},[_vm._v(" Try the new version ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }